import * as React from "react"
import { findActivePath } from "@digits-shared/components/Router/useRoutePathAndMatch"
import { SvgHome02 } from "@digits-shared/components/SVGIcons/line/Home02.svg"
import { HeaderSubNav } from "@digits-shared/DesignSystem/Containers/Headers/HeaderSubNav"
import { HeaderToggles } from "@digits-shared/DesignSystem/Containers/Headers/HeaderToggles"
import { ToggleLinkOption } from "@digits-shared/DesignSystem/FormElements/ToggleButtons"
import { ApplicationHeaderWithAI } from "src/frontend/components/OS/Applications/Shared/Headers/ApplicationHeaderWithAI"
import { useFrontendPathAndMatch } from "src/frontend/hooks/useFrontendPathAndMatch"
import routes from "src/frontend/routes"

/*
  COMPONENTS
*/

export const HomeApplicationHeader: React.FC = () => (
  <ApplicationHeaderWithAI SubNav={HomeSubNav}>
    <SvgHome02 />
    Home
  </ApplicationHeaderWithAI>
)

const HomeSubNav: React.FC = () => {
  const homeMatch = useFrontendPathAndMatch(routes.legalEntityHome)
  const revenueMatch = useFrontendPathAndMatch(routes.revenue)
  const expensesMatch = useFrontendPathAndMatch(routes.expenses)
  const defaultValue = findActivePath([revenueMatch, expensesMatch], homeMatch)

  return (
    <HeaderSubNav>
      <HeaderToggles defaultValue={defaultValue}>
        <ToggleLinkOption data-testid="home-title" to={homeMatch[0]}>
          Dashboard
        </ToggleLinkOption>
        <ToggleLinkOption to={expensesMatch[0]}>Expenses</ToggleLinkOption>
        <ToggleLinkOption to={revenueMatch[0]}>Revenue</ToggleLinkOption>
      </HeaderToggles>
      <div css="display: flex; align-items: center; gap: 16px" id="analysis-toggle" />
    </HeaderSubNav>
  )
}
